import React, { memo } from 'react';

import { green, blue, white, gray } from 'utils/style/colors';

import { LoadingSVGContainer } from './styles';

interface IComponentProps {
  color?: Colors;
  customStyle?: React.CSSProperties;
  width?: number;
}

export type Colors = 'blue' | 'white' | 'gray';

const setColor = {
  blue,
  white,
  gray,
};

export const LoadingIcon: React.FC<IComponentProps> = ({
  color,
  customStyle,
  width = 24,
}) => {
  const selectedColor = color ? setColor[color] : green;
  return (
    <LoadingSVGContainer
      width={`${width}px`}
      height={`${width}px`}
      style={customStyle}
      viewBox="0 0 50 50"
    >
      <path
        fill={selectedColor}
        stroke={selectedColor}
        strokeWidth="2"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </LoadingSVGContainer>
  );
};

export default memo(LoadingIcon);
